var _path, _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBinPaperPinYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 48,
    viewBox: "0 0 33 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6434 16.3217C32.6434 25.3359 16.3217 47.4813 16.3217 47.4813C16.3217 47.4813 0 25.3359 0 16.3217C0 7.30747 7.30747 0 16.3217 0C25.3359 0 32.6434 7.30747 32.6434 16.3217Z",
    fill: "#EFDB22"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 11,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_830_6358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9482 10.2856H13.2499C12.9373 10.2856 12.6375 10.4098 12.4165 10.6308C12.1955 10.8519 12.0713 11.1516 12.0713 11.4642V19.7142H19.9284V13.2659L16.9482 10.2856ZM17.1784 11.6269L18.5872 13.0356H17.1784V11.6269ZM12.857 18.9285V11.4642C12.857 11.36 12.8984 11.2601 12.9721 11.1864C13.0457 11.1127 13.1457 11.0714 13.2499 11.0714H16.3927V13.8214H19.1427V18.9285H12.857Z",
    fill: "black",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_830_6358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.42857,
    height: 9.42857,
    fill: "white",
    transform: "translate(11.2856 10.2856)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinPaperPinYellow);
export default __webpack_public_path__ + "static/media/trash-bin-paper-pin-yellow.3763a20bcb131b2ff70db55a79fcf169.svg";
export { ForwardRef as ReactComponent };